import { AwsRum } from 'aws-rum-web';

export default function initRum(): void {
  const appMonitorId = import.meta.env.VITE_RUM_APP_MONITOR_ID;
  const identityPoolId = import.meta.env.VITE_RUM_IDENTITY_POOL_ID;

  if (
    !appMonitorId
    || !identityPoolId
    || window.location.host.includes('localhost')
  ) return;

  // eslint-disable-next-line no-new
  new AwsRum(appMonitorId, '1.0.0', 'eu-west-2', {
    sessionSampleRate: 1,
    identityPoolId,
    endpoint: 'https://dataplane.rum.eu-west-2.amazonaws.com',
    telemetries: ['errors', 'performance', 'http'],
    allowCookies: true,
    enableXRay: false,
  });
}
